import React from 'react';
import CalendarFareInMonth from './CalendarFareInMonth';

function Section03(props: any) {
  const {
    onSearchFlight, selectedDate, dayPriceObjStatictis,
  } = props;
  return (
    <CalendarFareInMonth
      type="depart"
      onSearchFlight={onSearchFlight}
    />
  );
}

export default React.memo(Section03);
